import { render, staticRenderFns } from "./MyBalance.vue?vue&type=template&id=37d93100"
import script from "./MyBalance.vue?vue&type=script&lang=js"
export * from "./MyBalance.vue?vue&type=script&lang=js"
import style0 from "./MyBalance.vue?vue&type=style&index=0&id=37d93100&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports